import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EPSurvey from 'editor-components/survey/EPSurvey';
import { getShowFeedbackTime, getHideFeedbackTime, setInFeedbackSession, getInFeedbackSession, getHasDismissedFeedback, setHasDismissedFeedback } from 'ContentEditorUI/js/utils/PatagoniaFeedbackUtils';
import { getHasSeenPatagoniaFeedbackCount, getHasRespondedPatagoniaFeedback
// @ts-expect-error not yet migrated
} from 'ContentEditorUI/js/redux/selectors/settingsSelectors';

// @ts-expect-error not yet migrated
import { updateHasSeenPatagoniaFeedbackCount } from 'ContentEditorUI/js/redux/actions/settingsActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';

// @ts-expect-error not yet migrated
import { setHasRespondedPatagoniaFeedback } from 'ContentEditorUI/js/redux/actions/settingsActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const SurveyContainer = () => {
  //if feedback badge is left open while going to other apps or page gets refreshed keep it open
  const isInFeedbackSession = getInFeedbackSession();

  //if manually dismisses feedback badge before responding - dont show again till next session
  const hasDismissedFeedback = getHasDismissedFeedback();

  //if feedback badge has been displayed or closed total of 3 times without interaction do not show again
  const hasSeenPatagoniaFeedbackCount = useSelector(getHasSeenPatagoniaFeedbackCount);

  //does not show feedback badge if already has given feedback
  const hasRespondedPatagoniaFeedback = useSelector(getHasRespondedPatagoniaFeedback);
  const dispatch = useDispatch();
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(isInFeedbackSession);
  const [hasSubmittedFeedback, setHasSubmittedFeedback] = useState(false);
  const shouldShowFeedbackButton = hasSeenPatagoniaFeedbackCount < 3 && !hasRespondedPatagoniaFeedback && !hasDismissedFeedback;
  const setFeedbackAsSubmitted = useCallback(() => {
    setHasSubmittedFeedback(true);
  }, [setHasSubmittedFeedback]);
  const closeFeedbackBadge = useCallback((isSubmitted = true) => {
    setInFeedbackSession(false);
    if (!isSubmitted && shouldShowFeedbackButton) {
      dispatch(updateHasSeenPatagoniaFeedbackCount());
      setHasDismissedFeedback(true);
    }
    if (hasSubmittedFeedback) {
      dispatch(setHasRespondedPatagoniaFeedback());
    }
    setIsFeedbackOpen(false);
  }, [dispatch, shouldShowFeedbackButton, hasSubmittedFeedback]);
  const handleTracking = useCallback(feedbackObj => {
    return UsageTracker.trackEditorInteraction({
      action: 'Feedback Action',
      event: 'Patagonia Feedback Response',
      isPositiveFeedback: feedbackObj.isPositive,
      feedbackText: feedbackObj.feedbackMessage
    });
  }, []);
  useEffect(() => {
    const showFeedbackTime = getShowFeedbackTime();
    const hideFeedbackTime = getHideFeedbackTime();
    let hideFeedbackTimeoutId;
    if (shouldShowFeedbackButton) {
      setTimeout(() => {
        setIsFeedbackOpen(true);
        setInFeedbackSession(true);
      }, showFeedbackTime);
      hideFeedbackTimeoutId = setTimeout(() => {
        closeFeedbackBadge(false);
      }, hideFeedbackTime);
    }
    return () => {
      if (hideFeedbackTimeoutId) {
        clearTimeout(hideFeedbackTimeoutId);
      }
    };
  }, [closeFeedbackBadge, shouldShowFeedbackButton]);
  if (!shouldShowFeedbackButton || !isFeedbackOpen) {
    return null;
  } else {
    return /*#__PURE__*/_jsx(EPSurvey, {
      closeFeedbackBadge: closeFeedbackBadge,
      setFeedbackAsSubmitted: setFeedbackAsSubmitted,
      handleTracking: handleTracking,
      mainTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "amplitudeSurvey.mainTitle"
      }),
      formTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "amplitudeSurvey.formTitle"
      })
    });
  }
};
export default SurveyContainer;